<template>
  <div>
    <!--coupon manager vue2 template-->
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
    >
      <el-form-item label="优惠券名称">
        <el-input v-model="searchForm.couponName" clearable></el-input>
      </el-form-item>
      <el-form-item label="优惠券类型">
        <el-select v-model="searchForm.type" clearable filterable>
          <el-option
            v-for="item in couponTypeOptions"
            :key="item.paraValue"
            :label="item.paraName"
            :value="item.paraValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有效期类型">
        <el-select v-model="searchForm.validityType" clearable filterable>
          <el-option
            v-for="item in couponValidityTypeOptions"
            :key="item.paraValue"
            :label="item.paraName"
            :value="item.paraValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!--buttons-->
    <div style="margin-bottom: 10px">
      <el-button size="mini" @click="gotoSubscriberCoupon"
        >会员优惠券</el-button
      >
    </div>

    <!--element-ui table page-->
    <el-table
      :data="couponList"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="title" label="优惠券名称"></el-table-column>
      <el-table-column prop="type" column-key="type" label="优惠券类型">
        <template slot-scope="scope">
          <span>{{
            scope.row.type | couponTypeFilter(couponTypeOptions)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="validityType" label="有效期类型">
        <template slot-scope="scope">
          <span
            >{{
              scope.row.validityType
                | couponValidityTypeFilter(couponValidityTypeOptions)
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="优惠券面额"></el-table-column>
      <el-table-column prop="total" label="发放总量"></el-table-column>
      <el-table-column prop="received" label="已领取数量"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span
            >{{ scope.row.status | couponStatusFilter(couponStatusOptions) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="created" label="创建时间"></el-table-column>
      <el-table-column prop="modified" label="更新时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleEdit(scope.row)"
            >编辑</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <coupon-edit ref="couponEditRef" @success="loadPage(1)"></coupon-edit>
  </div>
</template>

<script>
import { selectParameterInfoBusiness } from "@/api/api";
import { storeCouponPage } from "@/api/store";
import couponEdit from "./components/couponEdit";
export default {
  filters: {
    couponTypeFilter(type, couponTypeOptions) {
      if (couponTypeOptions && couponTypeOptions.length > 0) {
        return couponTypeOptions.find(item => item.paraValue == type).paraName;
      }
      return type;
    },
    couponValidityTypeFilter(type, couponValidityTypeOptions) {
      if (couponValidityTypeOptions && couponValidityTypeOptions.length > 0) {
        return couponValidityTypeOptions.find(item => item.paraValue == type)
          .paraName;
      }
      return type;
    },
    couponStatusFilter(type, couponStatusOptions) {
      if (couponStatusOptions && couponStatusOptions.length > 0) {
        return couponStatusOptions.find(item => item.value == type).label;
      }
      return type;
    }
  },
  components: {
    couponEdit
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      couponValidityTypeOptions: [],
      couponTypeOptions: [],
      couponStatusOptions: [
        {
          label: "未开始",
          value: 0
        },
        {
          label: "进行中",
          value: 1
        },
        {
          label: "已结束",
          value: 2
        }
      ],
      couponList: [],
      loading: false
    };
  },
  created() {
    this.getBizCouponTypeOptions();
    this.getBizCouponValidityTypeOptions();
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      storeCouponPage(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.couponList = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 新增
     */
    handleAdd() {
      this.$refs.couponEditRef.show();
    },
    handleEdit(row) {
      const id = row.id;
      this.$refs.couponEditRef.show(id);
    },
    getBizCouponTypeOptions() {
      let _self = this;
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "biz_coupon_type"
      }).then(resp => {
        if (resp.data.results) {
          _self.couponTypeOptions = resp.data.results.list.map(e => {
            e.paraValue = Number(e.paraValue);
            return e;
          });
        }
      });
    },
    getBizCouponValidityTypeOptions() {
      let _self = this;
      selectParameterInfoBusiness({
        startRows: 1,
        pageSize: 100,
        paraType: "biz_coupon_validity_type"
      }).then(resp => {
        if (resp.data.results) {
          _self.couponValidityTypeOptions = resp.data.results.list.map(e => {
            e.paraValue = Number(e.paraValue);
            return e;
          });
        }
      });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    gotoSubscriberCoupon() {
      this.$router.push({
        path: "/storeSubscriberCoupon"
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// index.vue?9dc062d8